import { captureException } from '@sentry/react';
import {
  useBookingAddress,
  useBookingCars,
  useBookingSelectedSalesItemsCars,
  useBookingTimeWindow,
  useBookingType
} from '../pages/BookingFlow/bookingStore';

export function useGetBookingTrackingParams() {
  const cars = useBookingCars();
  const salesItems = useBookingSelectedSalesItemsCars();
  const bookingType = useBookingType();
  const selectedAddress = useBookingAddress();
  const timeWindow = useBookingTimeWindow();

  try {
    return {
      cars: cars.map((car) => car.licensePlate.number),
      numberOfCars: cars.length,
      address: selectedAddress,
      salesItems: salesItems.map((item) => item.salesItemId),
      pickUpAddresses: [
        ...new Set(salesItems.map((item) => item.metaData?.selectedTireHotelPickUpAddress?.id ?? null).filter(Boolean))
      ],
      bookingCategories: [...new Set(salesItems.map((item) => item.bookingCategorySlug))],
      bookingType,
      timeWindow
    };
  } catch (error) {
    captureException(error);
    return null;
  }
}
